var map = {
	"./aweme.png": "44fa",
	"./ohayoo.png": "07e5",
	"./pangolin.png": "e7d6",
	"./tomato_novel_app.png": "9a57",
	"./toutiao.png": "5d08",
	"./union.png": "639c",
	"./video_app.png": "ba90"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2cc6";